import { TablePagination } from "@mui/material";

export const TableComponent = ({ page, handleChangePage, data, children }) => {
  const allKeys = Array.from(new Set(data.flatMap((row) => Object.keys(row))));
  return (
    <>
      <div className="overflow-x-auto">
        <table className="table-auto min-w-full border-collapse">
          <thead>
            <tr className="bg-purple-700 text-white font-bold">
              {allKeys.map((column, index) => (
                <th
                  key={`header-${index}`}
                  style={{
                    minWidth: column === "Feedback" ? "300px" : column === "NPS" ? "150px" : "100px",
                  }}
                  className="px-4 py-2 whitespace-nowrap"
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
           {children}
          </tbody>
        </table>
      </div>

      <TablePagination
        rowsPerPageOptions={[]}
        sx={{
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-input": {
            fontSize: "14px",
            color: "white",
          },
          "& .MuiTablePagination-actions button": { color: "#fff" },
          "& .MuiTablePagination-displayedRows": {
            fontSize: "14px",
            color: "white", // Change color
            fontWeight: "bold",
          },
        }}
        component="div"
        count={data.length}
        rowsPerPage={15}
        page={page}
        onPageChange={handleChangePage}
      />
    </>
  );
};
